module.exports = __webpack_public_path__ + "img/girl-head-front.69ece628.png";